import GetPOSAdvices from './GetPOSAdvices'

export default GetPOSAdvices
